module.exports = __webpack_public_path__ + "static/media/thumb_movie.9c047088.jpg";